import { createAsyncThunk } from '@reduxjs/toolkit';
import { Flavor } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchFlavor, FindFlavor, GetFlavor } from './interface';

export const createFlavor = createAsyncThunk(
  'flavor/createFlavor',
  async (values: CreatePatchFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findFlavor = createAsyncThunk('flavor/findFlavor', async (values: FindFlavor, { rejectWithValue }) => {
  try {
    const response = await Flavor.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getFlavor = createAsyncThunk(
  'flavor/getFlavor',
  async ({ id }: GetFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchFlavor = createAsyncThunk(
  'flavor/patchFlavor',
  async ({ id, ...values }: CreatePatchFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
